// src/services/accountService.js
import { apiRequest } from "./apiService";

/**
 * Account endpoints
 */

export const changePassword = (payload) =>
  apiRequest("/change-password", "PUT", payload);